import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { resumeLeave } from "../../api/hr";
import { RequestCardRow } from "./RequestCardRow";

export const RequestStatusList = ({ data, reload }) => {
  const { t } = useTranslation();
  const doResume = async (id) => {
    if (!window.confirm(t("myRequests.resumeConfirm"))) return;
    try { await resumeLeave(id); toast.success(t("myRequests.resumeDone")); reload?.(); }
    catch { toast.error(t("errors.generic")); }
  };
  const rows = [
    ...(data.leaves || []).map((l) => ({
      id: l.id, kind: "leave", leaveType: l.leave_type, typeLabel: t(`leaves.types.${l.leave_type}`),
      title: `${l.start_date} → ${l.end_date}`, ref: l.ref_no,
      detail: t("leaves.detail", { total: l.total_days, paid: l.paid_days, unpaid: l.unpaid_days }),
      status: l.status, note: l.decision_note,
      canResume: ["pending", "approved"].includes(l.status),
      needCertificate: l.leave_type === "sick" && l.status === "pending" && !l.certificate_url,
    })),
    ...(data.timeOff || []).map((o) => ({
      id: o.id, kind: "timeOff", leaveType: "time_off", typeLabel: t("leaves.types.time_off"),
      title: `${t(`timeOff.type.${o.time_off_type}`)} · ${o.request_date}`, ref: o.ref_no,
      detail: t("timeOff.hoursValue", { count: o.hours }), status: o.status, note: o.decision_note,
    })),
    ...(data.advances || []).map((a) => ({
      id: a.id, kind: "advance", typeLabel: t("myRequests.advance"),
      title: `${a.amount} ${a.currency}`, ref: a.ref_no,
      detail: t("advances.installment", { amount: a.monthly_installment, currency: a.currency }),
      status: a.status, note: a.decision_note,
    })),
    ...(data.resignations || []).map((r) => ({
      id: r.id, kind: "resignation", typeLabel: t("myRequests.resignation"), title: t("resignation.title"),
      detail: t("resignation.lastDayIs", { date: r.last_working_day, count: r.notice_days }),
      status: r.status, note: r.decision_note,
    })),
  ];

  return (
    <div data-testid="my-requests-list" className="grid gap-3">
      <p className="label-xs text-base">{t("myRequests.history")}</p>
      {!rows.length ? (
        <p className="text-base text-muted-foreground" data-testid="my-requests-empty">{t("myRequests.empty")}</p>
      ) : (
        rows.map((row) => (
          <RequestCardRow key={`${row.kind}-${row.id}`} row={row} onResume={doResume} reload={reload} />
        ))
      )}
    </div>
  );
};
